import React, { useEffect, useState } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    TablePagination,
    Box,
    Grid,
    Typography
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { Link, useNavigate } from 'react-router-dom'
import { ApiDeleteAddOnQuestionData, ApiGetAddOnQuestionData } from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'


const AddOnQuestion: React.FC = () => {
    const [addOnquestions, setAddOnquestions] = useState<any[]>([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [datalength, setdatalength] = useState<any>(null);


    const navigate = useNavigate();

    const handleDeleteaddOn = async (id: number) => {
        try {
            const res = await ApiDeleteAddOnQuestionData(`?addOnQuestionId=${id}`)
            toast.success(res.message);
            handleApiGetaddOnJson();
        } catch (error) {
            console.error('Error deleting addOn:', error)
            toast.error('Failed to delete addOn')
        }
    }


    useEffect(() => {
        handleApiGetaddOnJson()
    }, [page, rowsPerPage])

    const handleApiGetaddOnJson = async () => {
        const data = `?offset=${rowsPerPage * page}&limit=${rowsPerPage}`;
        try {
            const res = await ApiGetAddOnQuestionData(data)
            setdatalength(res.total)
            setAddOnquestions(res.data)
        } catch (error) {
            toast.error("Error Getting Add on Questions.")
            console.error('Error Getting addOn Question:', error)
        }
    }
    //   // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <div className='w-100 p-2'>
            <Box className='p-2 bg-white py-3 w-100 border-10'>
                <Grid className='w-100 mb-4 mt-3 align-items-center' gap={2} container>
                    <Grid size={{ xs: 12, md: "grow" }}>
                        <Typography className='fs-42 text-center'>Add On Question</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: "auto" }}>
                        <div className='d-flex justify-content-end'>
                            <Link
                                to={`/admin/others/add/add-on-question`}
                                className='table-row-background link-btn'
                            >
                                Create Add On Question
                            </Link>
                        </div>{' '}
                    </Grid>
                </Grid>
                {/* <TableContainer component={Paper}> */}
                <Box className='w-100' overflow={'auto'}>
                    <Table>
                        <TableHead>
                            <TableRow className='table-row-background'>
                                {['Add on Question', 'Add on Type', 'Delete'].map(
                                    items => (
                                        <TableCell className='tableCell-header' sx={{ width: `${100 / 3}%`, textAlign: 'center' }}>{items}</TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {addOnquestions.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={3} align="center" sx={{ py: 3, fontWeight: "bold" }}>
                                        No Add On Question Found
                                    </TableCell>
                                </TableRow>
                            ) : (
                                addOnquestions.map((addOn) => (
                                    <TableRow key={addOn.addOnQuestionId}>
                                        <TableCell sx={{ width: "33%", textAlign: "center" }}>
                                            {addOn.addOnQuestionText}
                                        </TableCell>
                                        <TableCell sx={{ width: "33%", textAlign: "center" }}>
                                            {addOn.addOnQuestionType}
                                        </TableCell>
                                        <TableCell sx={{ width: "33%", textAlign: "center" }}>
                                            <Button
                                                variant="contained"
                                                className="delete-transparent"
                                                onClick={() => handleDeleteaddOn(addOn.addOnQuestionId)}
                                            >
                                                <DeleteIcon className="delete-icon" />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </Box>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                {/* </TableContainer> */}
            </Box>
        </div>
    )
}

export default AddOnQuestion;
